import { Button, Row, Space, Tooltip, Modal, Form } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import moment from 'moment'
import Uploadfiles from '../../modules/uploadfiles'
import {
  UndoOutlined,
  CloseCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons'
import { ColumnsType } from 'antd/lib/table'
import {
  DOWNLOAD_CONTRACT_FILE,
  LandingContractPageDTO,
} from '@/api/paymentOrder'
import {
  signingTypeEnum,
  fileReviewStateEnum,
  eSignProcessStatusEnum,
} from '@/global/enum'
import ContractTag from '@/pages/contract/components/ContractTag'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { cn } from '@xhgj/xh-jsutils'
import { CAN_DOWNLOAD_CONTRACT_ATTACHMENT } from '@/global/config/contract'

export const contractPendingAttachmentRender = (
  text: any,
  record: LandingContractPageDTO,
) => {
  if (signingTypeEnum.isLabelIn(record.signingType as any, ['纸质合同'])) {
    return (
      <Button type="link" onClick={() => DOWNLOAD_CONTRACT_FILE([record.id!])}>
        下载
      </Button>
    )
  } else if (
    signingTypeEnum.isLabelIn(record.signingType as any, [
      '全电子合同',
      '我方电子对方纸质合同',
    ])
  ) {
    return (
      <>
        {record.contractPendingAttachment ? (
          <Button
            type="link"
            onClick={() => window.open(record.contractPendingAttachment)}
          >
            去签署
          </Button>
        ) : (
          '-'
        )}
      </>
    )
  }
}
export default function contract() {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    showList,
    setShowList,
    warningStatus,
    fileList,
    reason,
    downloadFile,
    getAttachment,
    searchRef,
    inTableUploadfile,
    setContractId,
    fileListChange,
    fileStatus,
    uploadRef,
    cancelUpload,
    confirmUpload,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state

  const columns: ColumnsType<LandingContractPageDTO> = [
    {
      key: 'contractNo',
      dataIndex: 'contractNo',
      title: '合同号',
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '合同类型',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '创建时间',
      render: (text: string) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'cooperationValidity',
      dataIndex: 'cooperationValidity',
      title: '合作时间',
    },
    {
      key: 'secondSigningSupplierId',
      dataIndex: 'secondSigningSupplierId',
      title: '对方签约主体',
    },
    {
      key: 'fileDTO',
      dataIndex: 'fileDTO',
      title: '合同附件',
      render: (text: any[], record: any) => {
        const fileList = record.fileDTO ? [record.fileDTO] : []
        // 没有附件，并且纸质合同能上传
        if (
          !record.fileReviewState &&
          signingTypeEnum.isLabelIn(record.signingType as any, [
            '纸质合同',
            '我方电子对方纸质合同',
          ])
        ) {
          if (
            signingTypeEnum.isLabelIn(record.signingType as any, [
              '我方电子对方纸质合同',
            ])
          ) {
            if (
              !eSignProcessStatusEnum.isValueInLabels(
                record.eSignProcessStatus,
                ['已完成'],
              )
            ) {
              return '-'
            }
          }
          return (
            <Uploadfiles
              title="上传"
              dataSource={fileList}
              onChange={(e: fileFile[]) => {
                inTableUploadfile({ e, isOld: true, id: record.id, record })
              }}
              accept=".pdf,.png,.jpg,.jpeg"
              maxCount={1}
              type="contract"
              code="file"
              uploadBtnStyle={{
                border: 'none',
                fontSize: '12px',
                color: '#3B44D3',
                backgroundColor: '#fff',
              }}
              hiddenDownload={!CAN_DOWNLOAD_CONTRACT_ATTACHMENT}
              customerConfirmTitle="您正在删除合同附件"
              customerConfirmContent="是否确认？"
            />
          )
        }
        // 检查是否匹配ContractTag的条件
        if (
          fileReviewStateEnum.isLabelIn(record.fileReviewState, [
            '未通过',
            '审批中',
          ])
        ) {
          return (
            <ContractTag
              record={record}
              onTagClick={(record, status) => getAttachment(record, status)}
            />
          )
        } else if (
          fileReviewStateEnum.isLabelIn(record.fileReviewState, ['合同附件'])
        ) {
          // 审核通过且有权限时显示上传组件
          return (
            <div onClick={() => setContractId(record.id)}>
              <Uploadfiles
                title="上传"
                dataSource={fileList}
                onChange={(e: fileFile[]) => {
                  inTableUploadfile({ e, isOld: false, id: '', record })
                }}
                accept=".pdf,.png,.jpg,.jpeg"
                maxCount={1}
                type="contract"
                code="file"
                uploadBtnStyle={{
                  border: 'none',
                  fontSize: '12px',
                  color: '#3B44D3',
                  backgroundColor: '#fff',
                }}
                hiddenDownload={!CAN_DOWNLOAD_CONTRACT_ATTACHMENT}
                disabledDel // 无需删除功能
                customerConfirmTitle="您正在删除合同附件"
                customerConfirmContent="是否确认？"
              />
            </div>
          )
        }
        // 默认情况下显示 '-'
        return '-'
      },
    },
    {
      key: 'signingType',
      dataIndex: 'signingType',
      title: '签订方式',
    },
    {
      key: 'contractPendingAttachment',
      title: '合同待签署文件',
      align: 'left',
      width: 70,
      render: contractPendingAttachmentRender,
    },
    // {
    //   key: 'signatureStatus',
    //   dataIndex: 'signatureStatus',
    //   title: '签章状态',
    // },
    {
      key: 'contractStatus',
      dataIndex: 'contractStatus',
      title: '合同状态',
    },
    {
      key: 'accruingAmounts',
      dataIndex: 'accruingAmounts',
      title: '累计金额',
    },
  ]
  const fileReviewState = fileStatus?.fileReviewState
  const fileReviewStateLabel = fileReviewStateEnum.getLabelByValue(
    fileReviewState as any,
  )
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'contractNum',
          'contractType',
          'secondSigningSupplierId',
          'signingType',
          'landingContractStatus',
        ]}
        onSearch={handleSearchClick}
        keyName="LOCALCONTRACT"
        ScreenKey="LOCALCONTRACT"
        currentRef={searchRef}
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={() => handlePaginationChange(1)}></Buttonbar>
          <Tooltip
            title={
              <div style={{ color: 'black' }}>
                邮寄地址：浙江省杭州市拱墅区永福桥路与新天地街交叉口南180米咸亨科技大厦5楼
                <br />
                郭佳蕾 18767169579
              </div>
            }
            color="white"
          >
            <div className={styles['tooltip-text']}>邮寄地址</div>
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" type="primary" onClick={downloadFile}>
            下载合同
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns as any[]}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      <Modal
        title="合同附件"
        open={showList}
        onCancel={cancelUpload}
        footer={
          <Row justify={'end'}>
            {!fileReviewStateEnum.isValueInLabels(
              fileStatus?.fileReviewState || '',
              ['审批中'],
            ) && (
              <Button key="confirm" type="primary" onClick={confirmUpload}>
                确定
              </Button>
            )}
          </Row>
        }
      >
        <Form>
          <Form.Item
            label="合同附件"
            extra={
              fileReviewStateLabel !== '无效' && (
                <div
                  className={cn(
                    styles['warning-tip'],
                    fileReviewStateLabel === '合同附件' && styles['success'],
                    fileReviewStateLabel === '审批中' && styles['review'],
                    fileReviewStateLabel === '未通过' && styles['fail'],
                  )}
                >
                  <div className={styles['title']}>
                    {fileReviewStateLabel === '未通过' && (
                      <>
                        <CloseCircleFilled className={styles['icon']} />
                        审核未通过
                      </>
                    )}
                    {fileReviewStateLabel === '审批中' && (
                      <>
                        <LoadingOutlined spin className={styles['icon']} />
                        审批中
                      </>
                    )}
                  </div>
                  <div className={styles['text']}>
                    {fileReviewStateLabel === '合同附件' ? (
                      '您的合同附件识别通过'
                    ) : fileReviewStateLabel === '审批中' ? (
                      '请耐心等待结果~'
                    ) : (
                      <>
                        <p>{reason}</p>
                        <p>请重新上传合同附件</p>
                      </>
                    )}
                  </div>
                </div>
              )
            }
          >
            <Uploadfiles
              title="选择文件"
              dataSource={fileList ?? []}
              onChange={fileListChange}
              accept=".jpg,.png,.jpeg,.pdf,.gif"
              maxCount={1}
              type="contract"
              ref={uploadRef}
              disabledDel={fileReviewStateLabel !== '未通过'}
              // disabled
              // hiddenDownload
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
import { Button, Row, Space, Tooltip, Modal, Form } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import moment from 'moment'
import Uploadfiles from '../../modules/uploadfiles'
import {
  UndoOutlined,
  CloseCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons'
import { ColumnsType } from 'antd/lib/table'
import {
  DOWNLOAD_CONTRACT_FILE,
  LandingContractPageDTO,
} from '@/api/paymentOrder'
import {
  signingTypeEnum,
  fileReviewStateEnum,
  eSignProcessStatusEnum,
} from '@/global/enum'
import ContractTag from '@/pages/contract/components/ContractTag'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { cn } from '@xhgj/xh-jsutils'
import { CAN_DOWNLOAD_CONTRACT_ATTACHMENT } from '@/global/config/contract'

export const contractPendingAttachmentRender = (
  text: any,
  record: LandingContractPageDTO,
) => {
  if (signingTypeEnum.isLabelIn(record.signingType as any, ['纸质合同'])) {
    return (
      <Button type="link" onClick={() => DOWNLOAD_CONTRACT_FILE([record.id!])}>
        下载
      </Button>
    )
  } else if (
    signingTypeEnum.isLabelIn(record.signingType as any, [
      '全电子合同',
      '我方电子对方纸质合同',
    ])
  ) {
    return (
      <>
        {record.contractPendingAttachment ? (
          <Button
            type="link"
            onClick={() => window.open(record.contractPendingAttachment)}
          >
            去签署
          </Button>
        ) : (
          '-'
        )}
      </>
    )
  }
}
export default function contract() {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    showList,
    setShowList,
    warningStatus,
    fileList,
    reason,
    downloadFile,
    getAttachment,
    searchRef,
    inTableUploadfile,
    setContractId,
    fileListChange,
    fileStatus,
    uploadRef,
    cancelUpload,
    confirmUpload,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state

  const columns: ColumnsType<LandingContractPageDTO> = [
    {
      key: 'contractNo',
      dataIndex: 'contractNo',
      title: '合同号',
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '合同类型',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '创建时间',
      render: (text: string) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'cooperationValidity',
      dataIndex: 'cooperationValidity',
      title: '合作时间',
    },
    {
      key: 'secondSigningSupplierId',
      dataIndex: 'secondSigningSupplierId',
      title: '对方签约主体',
    },
    {
      key: 'fileDTO',
      dataIndex: 'fileDTO',
      title: '合同附件',
      render: (text: any[], record: any) => {
        const fileList = record.fileDTO ? [record.fileDTO] : []
        // 没有附件，并且纸质合同能上传
        if (
          !record.fileReviewState &&
          signingTypeEnum.isLabelIn(record.signingType as any, [
            '纸质合同',
            '我方电子对方纸质合同',
          ])
        ) {
          if (
            signingTypeEnum.isLabelIn(record.signingType as any, [
              '我方电子对方纸质合同',
            ])
          ) {
            if (
              !eSignProcessStatusEnum.isValueInLabels(
                record.eSignProcessStatus,
                ['已完成'],
              )
            ) {
              return '-'
            }
          }
          return (
            <Uploadfiles
              title="上传"
              dataSource={fileList}
              onChange={(e: fileFile[]) => {
                inTableUploadfile({ e, isOld: true, id: record.id, record })
              }}
              accept=".pdf,.png,.jpg,.jpeg"
              maxCount={1}
              type="contract"
              code="file"
              uploadBtnStyle={{
                border: 'none',
                fontSize: '12px',
                color: '#3B44D3',
                backgroundColor: '#fff',
              }}
              hiddenDownload={!CAN_DOWNLOAD_CONTRACT_ATTACHMENT}
              customerConfirmTitle="您正在删除合同附件"
              customerConfirmContent="是否确认？"
            />
          )
        }
        // 检查是否匹配ContractTag的条件
        if (
          fileReviewStateEnum.isLabelIn(record.fileReviewState, [
            '未通过',
            '审批中',
          ])
        ) {
          return (
            <ContractTag
              record={record}
              onTagClick={(record, status) => getAttachment(record, status)}
            />
          )
        } else if (
          fileReviewStateEnum.isLabelIn(record.fileReviewState, ['合同附件'])
        ) {
          // 审核通过且有权限时显示上传组件
          return (
            <div onClick={() => setContractId(record.id)}>
              <Uploadfiles
                title="上传"
                dataSource={fileList}
                onChange={(e: fileFile[]) => {
                  inTableUploadfile({ e, isOld: false, id: '', record })
                }}
                accept=".pdf,.png,.jpg,.jpeg"
                maxCount={1}
                type="contract"
                code="file"
                uploadBtnStyle={{
                  border: 'none',
                  fontSize: '12px',
                  color: '#3B44D3',
                  backgroundColor: '#fff',
                }}
                hiddenDownload={!CAN_DOWNLOAD_CONTRACT_ATTACHMENT}
                disabledDel // 无需删除功能
                customerConfirmTitle="您正在删除合同附件"
                customerConfirmContent="是否确认？"
              />
            </div>
          )
        }
        // 默认情况下显示 '-'
        return '-'
      },
    },
    {
      key: 'signingType',
      dataIndex: 'signingType',
      title: '签订方式',
    },
    {
      key: 'contractPendingAttachment',
      title: '合同待签署文件',
      align: 'left',
      width: 70,
      render: contractPendingAttachmentRender,
    },
    // {
    //   key: 'signatureStatus',
    //   dataIndex: 'signatureStatus',
    //   title: '签章状态',
    // },
    {
      key: 'contractStatus',
      dataIndex: 'contractStatus',
      title: '合同状态',
    },
    {
      key: 'accruingAmounts',
      dataIndex: 'accruingAmounts',
      title: '累计金额',
    },
  ]
  const fileReviewState = fileStatus?.fileReviewState
  const fileReviewStateLabel = fileReviewStateEnum.getLabelByValue(
    fileReviewState as any,
  )
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'contractNum',
          'contractType',
          'secondSigningSupplierId',
          'signingType',
          'landingContractStatus',
        ]}
        onSearch={handleSearchClick}
        keyName="LOCALCONTRACT"
        ScreenKey="LOCALCONTRACT"
        currentRef={searchRef}
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={() => handlePaginationChange(1)}></Buttonbar>
          <Tooltip
            title={
              <div style={{ color: 'black' }}>
                邮寄地址：浙江省杭州市拱墅区永福桥路与新天地街交叉口南180米咸亨科技大厦5楼
                <br />
                郭佳蕾 18767169579
              </div>
            }
            color="white"
          >
            <div className={styles['tooltip-text']}>邮寄地址</div>
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" type="primary" onClick={downloadFile}>
            下载合同
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns as any[]}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      <Modal
        title="合同附件"
        open={showList}
        onCancel={cancelUpload}
        footer={
          <Row justify={'end'}>
            {!fileReviewStateEnum.isValueInLabels(
              fileStatus?.fileReviewState || '',
              ['审批中'],
            ) && (
              <Button key="confirm" type="primary" onClick={confirmUpload}>
                确定
              </Button>
            )}
          </Row>
        }
      >
        <Form>
          <Form.Item
            label="合同附件"
            extra={
              fileReviewStateLabel !== '无效' && (
                <div
                  className={cn(
                    styles['warning-tip'],
                    fileReviewStateLabel === '合同附件' && styles['success'],
                    fileReviewStateLabel === '审批中' && styles['review'],
                    fileReviewStateLabel === '未通过' && styles['fail'],
                  )}
                >
                  <div className={styles['title']}>
                    {fileReviewStateLabel === '未通过' && (
                      <>
                        <CloseCircleFilled className={styles['icon']} />
                        审核未通过
                      </>
                    )}
                    {fileReviewStateLabel === '审批中' && (
                      <>
                        <LoadingOutlined spin className={styles['icon']} />
                        审批中
                      </>
                    )}
                  </div>
                  <div className={styles['text']}>
                    {fileReviewStateLabel === '合同附件' ? (
                      '您的合同附件识别通过'
                    ) : fileReviewStateLabel === '审批中' ? (
                      '请耐心等待结果~'
                    ) : (
                      <>
                        <p>{reason}</p>
                        <p>请重新上传合同附件</p>
                      </>
                    )}
                  </div>
                </div>
              )
            }
          >
            <Uploadfiles
              title="选择文件"
              dataSource={fileList ?? []}
              onChange={fileListChange}
              accept=".jpg,.png,.jpeg,.pdf,.gif"
              maxCount={1}
              type="contract"
              ref={uploadRef}
              disabledDel={fileReviewStateLabel !== '未通过'}
              // disabled
              // hiddenDownload
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
